<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Schedule Candidate for {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="scheduleCandidate()">

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Candidate Number</label>
        <input type="text" class="form-control " [(ngModel)]="schedule.examNo"
          [ngModelOptions]="{ standalone: true }" />
        <!-- <ng-select class="form-select" [(ngModel)]="schedule.examNo" [ngModelOptions]="{ standalone: true }">
            <ng-option selected value="0" disabled>Select Candidate</ng-option>
            <ng-option *ngFor="let candidate of candidateList" [value]="candidate.examNo">{{candidate.examNo}}</ng-option>
          </ng-select> -->
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Additional Minutes</label>
        <input type="number" min="0" class="form-control " [(ngModel)]="schedule.additionalMinutes"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Gap per batch(minutes)</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="schedule.gapPerBatch"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Count Per Time Slot</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="schedule.capacityPerSlot"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="row col-md-10 mb-3">
        <div class="col-md-5 mr-5">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input mr-1" required [(ngModel)]="schedule.randomiseVenues"
                [ngModelOptions]="{ standalone: true }">
              <label class="custom-control-label" for="customCheck1"> Randomize Venues</label>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input mr-1" required
                [(ngModel)]="schedule.notifyCandidatesByEmail" [ngModelOptions]="{ standalone: true }">
              <label class="custom-control-label" for="customCheck1"> Notify Candidates By Email</label>
            </div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit"> Schedule Candidate
      </button>
    </form>
  </div>
</div>